import { Link } from "react-router-dom";

const POSTS = [
  {
    slug: "pacific-family-reunion-polo-shirt-checklist",
    title: "Planning a Pacific Family Reunion: The Ultimate Polo Shirt Checklist",
    excerpt:
      "A step-by-step checklist for Samoan, Tongan and Cook Islands families planning a reunion — from numbers and themes through colours, sizing, group photos and lead times.",
    keyword: "pacific family reunion polo shirts",
    readTime: "9 min read",
    featured: true,
  },
  {
    slug: "design-custom-rugby-uniforms-nz",
    title: "How to Design Custom Rugby Uniforms in NZ",
    excerpt:
      "A practical guide for Kiwi rugby clubs — from picking colours and patterns to choosing fabric, sublimation vs DTF, sizing, and approving artwork.",
    keyword: "custom rugby uniforms nz",
    readTime: "7 min read",
  },
  {
    slug: "best-custom-uniforms-rugby-auckland",
    title: "Best Custom Uniforms for Rugby Teams in Auckland",
    excerpt:
      "Comparing the most-loved jersey styles, neck cuts, fabrics and design directions for Auckland rugby clubs heading into the new season.",
    keyword: "custom uniforms auckland",
    readTime: "6 min read",
  },
  {
    slug: "sublimation-vs-dtf-printing",
    title: "Sublimation vs DTF Printing for Team Uniforms",
    excerpt:
      "Which printing method is right for your team? We break down sublimation and DTF on durability, feel, colour, MOQ and turnaround.",
    keyword: "custom t shirt printing auckland",
    readTime: "8 min read",
  },
];

export default POSTS;
export function getPostBySlug(slug) {
  return POSTS.find((p) => p.slug === slug);
}

export function PostCard({ post, featured = false }) {
  return (
    <Link
      to={`/blog/${post.slug}`}
      data-testid={`post-card-${post.slug}`}
      className={`group block bg-zinc-900 border ${
        featured ? "border-gold/40" : "border-zinc-800"
      } hover:border-teal-400/50 transition-colors p-7 md:p-8 relative`}
    >
      {featured && (
        <span className="absolute -top-3 left-7 bg-gold text-zinc-950 text-[10px] font-bold uppercase tracking-wider px-2 py-1">
          New · Featured
        </span>
      )}
      <p className="text-xs uppercase tracking-[0.25em] text-teal-400 font-semibold">
        {post.readTime}
      </p>
      <h3 className="mt-3 font-display uppercase text-2xl md:text-3xl tracking-tight leading-tight group-hover:text-teal-400 transition-colors">
        {post.title}
      </h3>
      <p className="mt-4 text-zinc-400 text-sm leading-relaxed">{post.excerpt}</p>
      <div className="mt-6 inline-flex items-center gap-2 text-sm text-teal-400 font-semibold uppercase tracking-wider">
        Read article →
      </div>
    </Link>
  );
}
